import {FieldType, RulesConfiguration} from "controls/queryBuilder/ruleDefinition"

export function canApplyStringFilter(configuration: RulesConfiguration, field: string) {
	if (field == 'id')
		return false

	const fieldConfiguration = configuration[field]
	if (fieldConfiguration == null)
		return false

	return fieldConfiguration.type == FieldType.Text
		|| fieldConfiguration.type == FieldType.MultiSelect
		//|| fieldConfiguration.type == FieldType.Select select field does not make sense in the context of the grid filter
}
